<template>
  <form
    ref="form"
    novalidate
    class="container px-0 d-flex flex-column justify-content-between needs-validation"
    @submit="submit"
  >
    <div class="flex-grow-1">
      <div class="row">
        <BootstrapFormControl
          v-model="modelName"
          name="Objective Name"
          class="col"
          required
          :error="errorMessages.get('name')"
          :server-error="serverError"
        />
        <BootstrapFormControl
          v-model="modelMeasureType"
          name="Measure Type"
          class="col"
          disabled
          :error="errorMessages.get('type')"
          :server-error="serverError"
        />
      </div>
      <div class="row">
        <div class="col">
          <BootstrapCheck
            id="visibleForCustomer"
            v-model="modelVisible"
            label="Visible for Customer"
          />
        </div>
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelDefinition"
          name="Definition"
          class="col"
          required
          :error="errorMessages.get('definition')"
          :server-error="serverError"
          textarea
        />
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelDescription"
          name="Objective Description"
          class="col"
          required
          :error="errorMessages.get('description')"
          :server-error="serverError"
          textarea
        />
      </div>
      <div class="row">
        <BootstrapFormControl
          v-model="modelMeasurMethod"
          name="Measure Method"
          class="col-6"
          required
          :error="errorMessages.get('method')"
          :server-error="serverError"
          textarea
        />
        <BootstrapFormControl
          v-model="modelExceptions"
          name="Exceptions"
          class="col-6"
          :error="errorMessages.get('exceptions')"
          :server-error="serverError"
          textarea
        />
      </div>
      <slot />
      <div class="row mt-3">
        <div class="d-flex w-100">
          <BootstrapButton
            name="submit"
            class="me-2"
            type="submit"
            :disabled="loading"
            :loading="loading"
            @click.stop
          >
            Save
          </BootstrapButton>
          <BootstrapButton name="cancel" variant="secondary" @click="router.go(-1)">
            Cancel
          </BootstrapButton>
        </div>
      </div>
    </div>
  </form>
</template>
<script lang="ts" setup>
const props = defineProps<{
  definition: string;
  description: string;
  exceptions: string;
  errorMessages: Map<any, any>;
  loading: boolean;
  measureType: string;
  measureMethod: string;
  name: string;
  serverError: boolean;
  visible: boolean;
}>();

const emit = defineEmits<{
  'update:definition': [value: string];
  'update:description': [value: string];
  'update:exceptions': [value: string];
  'update:measureType': [value: string];
  'update:measureMethod': [value: string];
  'update:name': [value: string];
  'update:visible': [value: boolean];
  submit: [form: globalThis.Ref<HTMLFormElement | null>];
}>();

const router = useRouter();

// Template ref
const form = ref<HTMLFormElement | null>(null);

// Models
const modelDefinition = computed({
  get: () => props.definition,
  set: (value) => emit('update:definition', value),
});
const modelDescription = computed({
  get: () => props.description,
  set: (value) => emit('update:description', value),
});
const modelExceptions = computed({
  get: () => props.exceptions,
  set: (value) => emit('update:exceptions', value),
});
const modelMeasureType = computed({
  get: () => props.measureType,
  set: (value) => emit('update:measureType', value),
});
const modelMeasurMethod = computed({
  get: () => props.measureMethod,
  set: (value) => emit('update:measureMethod', value),
});
const modelName = computed({
  get: () => props.name,
  set: (value) => emit('update:name', value),
});
const modelVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value),
});

// https://getbootstrap.com/docs/4.6/components/forms/?#how-it-works
const submit = async (event: Event) => {
  if (form.value?.checkValidity() === false) {
    event.preventDefault();
    event.stopPropagation();
    form.value.classList.add('was-validated');
  } else {
    event.preventDefault();
    emit('submit', form);
  }
};
</script>
